module.exports = __webpack_public_path__ + "img/next-nfts-utility-bg.564c5ef7.png";